import React, {Component} from "react";
import {withTranslation} from "react-i18next";

import {Container, StyledMedia} from "../styles/CommonStyler";
import {isMobileOnly} from "react-device-detect";
import {Header} from "./Header";
import AuthBase from "./AuthBase";
import Footer from "./Footer";
import AuthButton from "./AuthButton";
import styled from "@emotion/styled";
import sv from "../styles/styles";

const Actions = styled(`div`)`
    margin-top: 24px;
    ${sv.flexRow}
`;

class Redirect extends Component {

    redirect = () => {
        window.location.replace(this.props.loc);
    };

    render = () => {
        const {t, loc, title} = this.props;

        this.redirect();    // could make this a scheduled thing in the future.

        return (
            <StyledMedia>
                <Container isMobile={isMobileOnly}>

                    <Header/>

                    <AuthBase title={title ? t(title) : ""}>
                        <>
                            {t("You're being redirected to")} {loc}
                        </>
                        <Actions>
                            <AuthButton cancel onClick={() => this.props.history.goBack()}>{t('Cancel')}</AuthButton>
                            <AuthButton onClick={this.redirect}>{t('Go now')}</AuthButton>
                        </Actions>
                    </AuthBase>
                    <Footer/>
                </Container>
            </StyledMedia>
        )
    }
}

const connectedRedirect = withTranslation()(Redirect);
export default connectedRedirect;
